import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.regexp.split";
import _typeof from "E:/wnmp/www/www.yunkezan.com/vuecli3/node_modules/@babel/runtime/helpers/esm/typeof.js";
export default {
  name: 'preferentialInstruction',
  props: {
    preferentialInstructionNew: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    preferentialInstruction: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      showMoreVisible: false,
      particalList: [] // 小于等于4的部分数据
    };
  },

  computed: {
    // 特殊说明是否可见
    showPreferentialInstruction: function showPreferentialInstruction() {
      return (this.preferentialInstructionNew || []).length;
    }
  },
  mounted: function mounted() {
    console.log('特殊说明');
    _typeof(window.componentCenter) == 'object' || (window.componentCenter = {});
    this.setRenderList();
    window.componentCenter.preferentialInstruction = this;
  },
  methods: {
    formatContent: function formatContent(content) {
      var contentList = content.split('\n');
      var notNoneContent = [];
      contentList.forEach(function (item) {
        item && notNoneContent.push(item);
      });
      console.log('contentList', notNoneContent);
      return notNoneContent;
    },
    setRenderList: function setRenderList() {
      if (this.preferentialInstructionNew.length < 4) {
        this.particalList = this.preferentialInstructionNew;
      } else {
        this.particalList = this.preferentialInstructionNew.slice(0, 4);
        this.showMoreVisible = true;
      }
    },
    showMoreList: function showMoreList() {
      this.showMoreVisible = false;
      this.particalList = this.preferentialInstructionNew;
    }
  }
};